import React, { useState } from 'react';
import BlurText from './BlurText';

const faqData = [
  {
    question: 'What is the difference between Rotating and Static proxies?',
    answer: `Rotating proxies are (ethically) sourced from household devices, therefore, using it makes them identical to any internet users.

It has two basic functions that you can choose of:

• Rotating: you will get a new IP address after every request, unless the IP is kept alive (such as using browsers)

• Sticky/Session: generate as much proxies as you need with a given length of time to keep the same IP address. Please note that due to the proxies are sourced from household devices, there is no guarantee for keeping the same IP for as long as you need.

Static proxies are hosted in data centers, ensuring high speed and reliability benefits.`
  },
  {
    question: 'How do you compare Rotating and Static proxies?',
    answer: `Here's a detailed comparison of the features available with each proxy type:`,
    hasTable: true
  },
  {
    question: 'Can proxies be detected?',
    answer: `Residential and ISP proxies are virtually undetectable, as they appear to be regular household connections to any website or service you access.

Datacenter proxies may be detectable if the target website actively filters such connections. However, for most use cases, they provide excellent performance and reliability.`
  },
  {
    question: 'What payment methods do you accept?',
    answer: `Currently, we only accept cryptocurrency payments:

• Bitcoin (BTC)
• Ethereum (ETH)
• USDT (Tether)

All payments are processed securely and anonymously. We're working on adding more payment methods in the future.`
  },
  {
    question: 'How do I get started with your proxies?',
    answer: `Getting started is quick and easy:

1. Choose your preferred proxy type (Rotating or Static)
2. Select your plan and complete the payment
3. Access your dashboard to generate proxy credentials
4. Configure your software or browser with the provided proxy settings
5. Start browsing securely!

Our support team is available 24/7 if you need any assistance with setup.`
  },
  {
    question: 'Do you offer refunds?',
    answer: `Yes, we offer a satisfaction guarantee. If you're not happy with our service within the first 24 hours of your purchase, you can request a full refund.

For technical issues that prevent you from using the service, our support team will work with you to resolve the problem. If we cannot resolve it, we will issue a refund for the unused portion of your subscription.

Please contact our support team for any refund requests.`
  }
];

const comparisonData = [
  { feature: 'Use the same IP address for long term', rotating: false, static: true },
  { feature: 'Access to the entire IP pool', rotating: true, static: false },
  { feature: 'Location targeting by country and city', rotating: true, static: false },
  { feature: 'Pay-as-you-go', rotating: true, static: false },
  { feature: 'Unlimited data', rotating: false, static: true },
  { feature: 'Unlimited concurrency', rotating: true, static: true },
  { feature: 'HTTP, HTTPS and SOCKS5 support', rotating: true, static: true },
  { feature: 'Available locations - countries', rotating: '100+', static: '20+' }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };

  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <h2 className="faq-title">
          <BlurText text="Frequently Asked Questions" delay={62} direction="top" />
        </h2>
        <p className="faq-subtitle">
          <BlurText text="Everything you need to know about our proxy services" delay={62} direction="bottom" />
        </p>

        <div className="faq-list">
          {faqData.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
            >
              <button
                className="faq-question"
                onClick={() => toggleFAQ(index)}
              >
                <span>{item.question}</span>
                <svg
                  className="faq-icon"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d={openIndex === index ? "M5 12H19" : "M12 5V19M5 12H19"}
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </button>

              <div className="faq-answer">
                <p>{item.answer}</p>

                {item.hasTable && (
                  <div className="comparison-table-wrapper">
                    <table className="comparison-table">
                      <thead>
                        <tr>
                          <th>Features</th>
                          <th>Rotating proxies</th>
                          <th>Static proxies</th>
                        </tr>
                      </thead>
                      <tbody>
                        {comparisonData.map((row, idx) => (
                          <tr key={idx}>
                            <td>{row.feature}</td>
                            <td>
                              {typeof row.rotating === 'boolean' ? (
                                row.rotating ? (
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M5 10L8 13L15 6" stroke="#E8FF00" strokeWidth="2"/>
                                  </svg>
                                ) : (
                                  <span className="table-x">✕</span>
                                )
                              ) : (
                                <span className="table-value">{row.rotating}</span>
                              )}
                            </td>
                            <td>
                              {typeof row.static === 'boolean' ? (
                                row.static ? (
                                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M5 10L8 13L15 6" stroke="#E8FF00" strokeWidth="2"/>
                                  </svg>
                                ) : (
                                  <span className="table-x">✕</span>
                                )
                              ) : (
                                <span className="table-value">{row.static}</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <p className="comparison-note">
                      NOTE: the above are not pros and cons, simply the nature of the different proxy types. Each suits different purposes of use.
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
